<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18FqACW/tc-custom/9780226493619.jpg?1736423607853" alt="This image is the cover for the book Going All City"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Going All City
      </h1>
      <p class="bookDescription body article font2">
        <b>A graffiti writer’s memoir: “A brave portrait of a highly criticized subculture and a look inside the reality of growing up in low-income Los Angeles.” —<i>LA Weekly</i></b><br/><br/><i>“We could have been called a lot of things: brazen vandals, scared kids, threats to social order, self-obsessed egomaniacs, marginalized youth, outsider artists, trend setters, and thrill seekers. But, to me, we were just regular kids growing up hard in America and making the city our own. Being ‘writers’ gave us something to live for and ‘going all city’ gave us something to strive for; and for some of my friends it was something to die for.”</i><br/><br/>In the age of commissioned wall murals and trendy street art, it’s easy to forget graffiti’s complicated and often violent past in the United States. Though graffiti has become one of the most influential art forms of the twenty-first century, cities nationwide waged a war against it from the late 1970s to the early 2000s, complete with brutal police task forces. Who were the vilified taggers they targeted? Teenagers, usually, from low-income neighborhoods with little to their names except a few spray cans and a desperate need to be seen—to mark their presence on city walls and buildings even as their cities turned a blind eye to them.<br/><br/><i>Going All City</i> is the mesmerizing and painful story of these young graffiti writers, told by one of their own. Prolific LA writer Stefano Bloch came of age in the late 1990s amid constant violence, poverty, and vulnerability. He recounts vicious interactions with police; debating whether to take friends with gunshot wounds to the hospital; coping with his mother’s heroin addiction; instability and homelessness; and his dread that his stepfather would get out of jail and tip his unstable life into full-blown chaos. But he also recalls moments of peace and exhilaration: marking a fresh tag; the thrill of running with his crew at night; exploring the secret landscape of LA; the dream and success of going all city.<br/><br/>Bloch holds nothing back in this fierce, poignant memoir—an unflinching portrait of a deeply maligned subculture and an unforgettable account of what writing on city walls means to the most vulnerable people living within them.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stefano Bloch
      </h2>
      
      <p class="authorDescription body article"><B>Stefano Bloch</B> is a cultural and urban geographer, ethnographer, and a semiretired graffiti writer from Los Angeles. He is assistant professor in the School of Geography and Development at the University of Arizona. This is his first book.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?063dca73